const uploadConfig = {
  region: process.env.REACT_APP_AWS_REGION,
  accessKeyId: process.env.REACT_APP_AWS_ACESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACESS_KEY
}

export default uploadConfig
